import * as React from "react";
import { useSelector } from "../../../../store";

import { Box, Typography, Divider } from "@mui/material";

export default function MobileComplete() {
	const clientState = useSelector((state) => state.client || {});
	const [learnerRedirectionURL, setLearnerRedirectionURL] = React.useState("");

	React.useEffect(() => {
		const url = clientState?.details?.preferences?.learnerRedirectionURL || "";
		if (!url) {
			setLearnerRedirectionURL("");
			return;
		}
		setLearnerRedirectionURL(/^https?:\/\//i.test(url) ? url : `https://${url}`);
	}, [clientState]);

	return (
		<React.Fragment>
			<Box
				sx={{
					bgcolor: "white",
					height: "100%",
					width: { xs: "100%", sm: "calc(100% - 4px)" },
					p: 3,
					overflow: "auto",
					borderRadius: "18px 18px 0px 0px",
				}}
			>
				<Typography
					variant="h3_bold"
					sx={{
						display: "flex",
						justifyContent: "center",
						mt: 1,
						color: "#06b6ad",
						textAlign: "center",
					}}
				>
					Language, Literacy & Numeracy Quiz Complete
				</Typography>
				<Divider sx={{ my: 5 }} />
				<Box
					component="div"
					className="redirect-button footer-button-container"
				>
					<a
						rel="noopener noreferrer"
						href={
							learnerRedirectionURL ||
							"https://tlrg.com.au/"
						}
						style={{
							fontSize: "1.4rem",
							marginTop: 1,
							borderRadius: "20px",
							padding: "5px 25px",
							backgroundColor: "#06b6ad",
							color: "white",
							textDecoration: "none",
							border: "none",
						}}
					>
						EXIT
					</a>
				</Box>
			</Box>
		</React.Fragment>
	);
}
